/**
 * Model to hold a single seeding criteria record.
 */
import { v4 as UUID } from 'uuid';
import { SeedingCriteriaType } from '@reg/shared/model/seeding-criteria-type.model';

export class SeedingCriteria {
    public isNew: boolean = true;
    public id: string = null;
    public name: string = null;
    public sequence: number = null;
    public eventId: string = null;
    public divisionId: string = null;
    public isSortOrderAscending: boolean = false;
    public seedingCriteriaType: SeedingCriteriaType = new SeedingCriteriaType();

    constructor(id: string = null, isNew: boolean = true) {
        this.id = id || UUID();
        this.isNew = isNew;
    }

    public isEmpty(): boolean {
        return !this.name && (!this.seedingCriteriaType || !this.seedingCriteriaType.id);
    }

    public isRecord(): boolean {
        return this.seedingCriteriaType && this.seedingCriteriaType.isRecord();
    }

    public clone(): SeedingCriteria {
        const clone: SeedingCriteria = new SeedingCriteria();
        clone.id = this.id;
        clone.isNew = this.isNew;
        clone.name = this.name;
        clone.sequence = this.sequence;
        clone.seedingCriteriaType = this.seedingCriteriaType && this.seedingCriteriaType.clone();
        clone.eventId = this.eventId;
        clone.divisionId = this.divisionId;
        clone.isSortOrderAscending = this.isSortOrderAscending;
        return clone;
    }

    /**
     * Serialize from a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'seedingCriteria';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.attributes.name = this.name;
        json.data.attributes.sequence = this.sequence;
        json.data.attributes.isSortOrderAscending = this.isSortOrderAscending;
        json.data.attributes.seedingCriteriaType = this.seedingCriteriaType.id;

        return JSON.stringify(json);
    }

    /**
     * Deserialize to a json api format
     */
    public deserialize(json: any): SeedingCriteria {
        const data: any = json['data'] || json;
        const attrs: any = data['attributes'];

        this.isNew = false;
        this.id = data.id;
        this.name = attrs.name;
        this.sequence = attrs.sequence;
        this.eventId = attrs.eventId;
        this.divisionId = attrs.divisionId;
        this.isSortOrderAscending = attrs.isSortOrderAscending;
        this.seedingCriteriaType = new SeedingCriteriaType(attrs.seedingCriteriaType);

        return this;
    }
}
